import React, { useEffect } from 'react'

import ReactPaginate, { ReactPaginateProps } from 'react-paginate'
import styled from 'styled-components'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleLeft, faAngleRight } from '@fortawesome/free-solid-svg-icons'

export type PaginationProps = {
  handlePageChange: (data: { selected: number }) => void,
  currentPage: number,
  totalPages: number,
  totalCount: number,
} & ReactPaginateProps

const ReactPaginateStyle = styled.div`
  ul {
    display: flex;
    justify-content: center;
    border-radius: 0.25rem;
    list-style: none;
    margin-top: 48px;
    padding-left: 0;
    margin-bottom: 8px;

    li {
      background-color: #fff;
      border: 1px solid #c8c8c8;
      color: #06aa6a;
      font-size: .875rem;
      font-weight: 700;
      line-height: 59px;
      text-align: center;
      margin: 0 -1px;
      padding: 0;
      width: 60px;
      height: 60px;

      a {
        display: block;
        background: none;
        border: none;
        color: #06aa6a;
        font-size: .875rem;
        font-family: Open Sans,sans-serif;
        font-weight: 700;
        text-decoration: none;
        width: 60px;
        height: 60px;
        margin: 0;
        padding: 0;
      }
    }

    .selected {
      background-color: #222222;
      color: white;
    }

    .previous {
      text-align: center;
      width: calc(50% - 30px);

      a {
        display: inline-block;
        color: #222222;
      }

      &.disable-label > a {
        color: ${props => props.theme.members.colors.silver._70};
      }
    }

    .next {
      text-align: center;
      width: calc(50% - 30px);

      a {
        display: inline-block;
        color: #222222;
      }

      &.disable-label > a {
        color: ${props => props.theme.members.colors.silver._70};
      }
    }

    @media ${props => props.theme.media.sm} {
      .disable-label {
        display: none;
      }

      .break {
        color: #a6aab6;
      }

      .previous {
        width: auto;

        a {
          display: block;
        }
      }

      .next {
        width: auto;

        a {
          display: block;
        }
      }

      li {
        color: #222222;
        line-height: 50px;
        min-width: 48px;
        width: auto;
        height: 52px;

        a {
          width: 48px;
          height: 48px;
        }
      }
    }
  }
`

export const StyledPagination: React.FC<PaginationProps> = (props: PaginationProps) => {
  const [currentPage, setCurrentPage] = React.useState(props.initialPage || 1)
  const isMobile = navigator.userAgent.match(/iPhone|Android.+Mobile|iPad/)
  const pageRangeDisplayed = isMobile ? 0 : props.pageRangeDisplayed
  const marginPagesDisplayed = isMobile ? 0 : props.marginPagesDisplayed
  const previousLabel = () => {
    if (isMobile) return <><FontAwesomeIcon icon={faAngleLeft} /><span> 前へ</span></>
    return <FontAwesomeIcon icon={faAngleLeft} />
  }
  const nextLabel = () => {
    if (isMobile) return <><span>次へ </span><FontAwesomeIcon icon={faAngleRight} /></>
    return <FontAwesomeIcon icon={faAngleRight} />
  }
  const breakLabel = isMobile ? '' : '...'

  useEffect(() => {
    setCurrentPage(props.initialPage || 1)
  }, [props.initialPage])

  return (
    <ReactPaginateStyle>
      <ReactPaginate
        onPageChange={props.handlePageChange}
        pageRangeDisplayed={pageRangeDisplayed}
        marginPagesDisplayed={marginPagesDisplayed}
        pageCount={props.totalPages}
        previousLabel={previousLabel()}
        nextLabel={nextLabel()}
        breakLabel={breakLabel}
        disabledClassName='disable-label'
        forcePage={currentPage - 1}
      />
    </ReactPaginateStyle>
  )
}
